﻿(function () {

    'use strict';
    var serviceId = 'repository.equipmenttracking';
    angular
        .module('app.services')
        .factory(serviceId, equipmenttracking);

    equipmenttracking.$inject = ['common', 'repository.abstract', '$http'];

    function equipmenttracking(common, abstractRepository, $http) {
        var config = common.config;
        function Ctor(mgr) {
            this.manager = mgr;
            this.getEquipmentsByNo = getEquipmentsByNo;
            this.getOperationTypes = getOperationTypes;
            this.getActivityTypes = getActivityTypes;
            this.getEquipmentTrackingById = getEquipmentTrackingById;
            this.getEquipmentTrackingByCriteria = getEquipmentTrackingByCriteria;
            this.getEquipmentActivityGateOperation = getEquipmentActivityGateOperation;
            this.getEquipmentActivityInspection = getEquipmentActivityInspection;
            this.getEquipmentActivityPTI = getEquipmentActivityPTI;
        }

        abstractRepository.extend(Ctor);
        return Ctor;

        function ajaxRolesCall() {
            var authData = common.localStorageService.get('authorizationData');
            var getIsRoleLoaded = (common.localStorageService.get('isRoleLoaded') != null) ? common.localStorageService.get('isRoleLoaded') : false;
            if (authData != null && authData.username != null) {
                if (authData.userRole != null) {
                    return;
                }
                var userName = authData.username;
                var SecurityRolesResponse = common.localStorageService.get('GetRolesByUserQuery');
                BussinesPartnerRolesResponse = common.localStorageService.get('GetBusinessPartnerUserRolesQuery');
            }
        }
        function getEquipmentsByNo(criterio) {
            var authData = common.localStorageService.get('authorizationData');
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentsByNoByUser?criteria=' + criterio + '&usuario=' + (authData ? authData.userRole : "") + '&isOnlyPortalUser=' + (authData ? authData.isOnlyPortalUser : false) );
        }
        function getOperationTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetDepotOrderOperationTypeList');
        }
        function getActivityTypes() {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetActivityTypesGTIGTO');
        }
        function getEquipmentTrackingById(equipmentId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentTrackingByIdGTIGTO?equipmentId=' + equipmentId);
        }
        function getEquipmentTrackingByCriteria(model) {
            return common.httpPost(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentTrackingByCriteria', model);
        }
        function getEquipmentActivityGateOperation(activityId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentActivityGateOperation?equipmentActivityId=' + activityId);
        }
        function getEquipmentActivityInspection(activityId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentActivityInspection?equipmentActivityId=' + activityId);
        }
        function getEquipmentActivityPTI(activityId) {
            return common.httpGet(config.basePaths.Base_Path_Resources + 'equipment/GetEquipmentActivityPTI?equipmentActivityId=' + activityId);
        }

    }

})();
